<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%;"
    ></Table>
    <br />
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableElasticBlockStoreSnapshotResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          title: this.$t("RAM.AWS.computeInstance.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.region"),
          key: "region"
        },
        {
          title: this.$t('RAM.AWS.EBSSnapshot.snapshotName'),
          key: "name"
        },
        {
          title: this.$t('RAM.AWS.EBSSnapshot.snapshotId'),
          key: "snapshotId"
        },
        {
          title: this.$t('RAM.AWS.EBSSnapshot.size'),
          key: "volumeSize"
        },
        {
          title: this.$t('RAM.AWS.EBSSnapshot.status'),
          key: "stateName"
        },
        {
          title: this.$t('RAM.AWS.EBSSnapshot.encryption'),
          key: "encrypted"
        },
        {
          title: this.$t('RAM.AWS.EBSSnapshot.associatedVolumeId'),
          key: "volumeId"
        },
        {
          title: this.$t('RAM.AWS.EBSSnapshot.startTime'),
          key: "startTime"
        }
      ],
      tableData: []
    };
  },
  beforeCreate: function() {
    tableDataVue = this;
  },
  mounted: function() {},
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function(val) {
      tableDataVue.companyId = val;
    });
    eventBus.$on("accountIds", function(val) {
      tableDataVue.accountIds = val;
    });
    eventBus.$on("accountName", function(val) {
      tableDataVue.accountName = val;
    });
    eventBus.$on("snapshotId", function(val) {
      tableDataVue.snapshotId = val;
    });
  },
  methods: {
    showAll: function() {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      this.$api.resourceManagement
        .pagingQueryAWSSnapshot({
          companyId: tableDataVue.companyId,
          accountIdList: tableDataVue.accountIds,
          accountName: tableDataVue.accountName,
          snapshotId: tableDataVue.snapshotId,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("companyId");
      eventBus.$off("accountIds");
      eventBus.$off("accountName");
      eventBus.$off("snapshotId");
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/ebs_snapshot/TableElasticBlockStoreSnapshotResource.vue